import styled from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';

export const WrapperMessageCoupon = styled.div`
  display: grid;
  grid-template-columns: 10% 90%;
  margin: 4px 0 8px ;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  animation: ease-out, ${fadeIn} 0.5s ease-out;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.surface.low};
`;

export const WrapperIconInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconInfo = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  object-position: center;
`;

export const MessageCoupon = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;
  color: #005299;
`;
